// apps/client/src/assets/blob.ts — DESIGN.md contact blob rgba(84,58,30,.45) → 0, a DataTexture so it builds without a canvas
import * as THREE from 'three';
let mat: THREE.MeshBasicMaterial | null = null;
export function blobMaterial(): THREE.MeshBasicMaterial {
  if (mat) return mat;
  const n = 64, data = new Uint8Array(n * n * 4);
  for (let y = 0; y < n; y++) for (let x = 0; x < n; x++) {
    const d = Math.hypot(x - n / 2 + 0.5, y - n / 2 + 0.5) / (n / 2);
    data.set([84, 58, 30, Math.round(Math.max(0, 1 - d) ** 1.6 * 0.45 * 255)], (y * n + x) * 4);
  }
  const tex = new THREE.DataTexture(data, n, n);
  tex.magFilter = tex.minFilter = THREE.LinearFilter;   // DataTexture defaults to nearest: keep the falloff soft
  tex.colorSpace = THREE.SRGBColorSpace;                // the DESIGN.md colour is sRGB
  tex.needsUpdate = true;
  mat = new THREE.MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false, polygonOffset: true, polygonOffsetFactor: -2 });
  return mat;
}
export function contactBlob(size: number): THREE.Mesh {
  const m = new THREE.Mesh(new THREE.PlaneGeometry(size, size).rotateX(-Math.PI / 2), blobMaterial());
  m.position.y = 0.02;
  m.renderOrder = -1;
  m.userData.blob = true;
  return m;
}
